@if (isVisible) {
  <div  [formGroup]="formGroup">
    <div class="grid-x">
      <div class="cell">
        <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-10 medium-10 small-12 padding-right-small">
        <input type="text" formControlName="inputValue" />
      </div>
      <div class="cell large-2 medium-2 small-12">
        <button class="button" (click)="add()" [disabled]="disableButton">{{buttonLabel}}</button>
      </div>
      <div class="cell large-12 medium-12 small-12">
        <ul style="list-style-type: none;">
          @for (item of listItems; track item; let i = $index) {
            <li>
              <span class="padding-left"><button (click)="remove(i)" [disabled]="disableButton"><svg-icon icon="icon-trash" class="small black"></svg-icon></button></span>{{item}}
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
}